import React, { useState } from "react";
import { useGetCelebrationListQuery } from "./GetCelebrationApiSlice";
import { useAppSelector } from "../../store/hooks";
import { useSaveCelebrationMutation } from "./SaveCelebrationApiSlice";
import { Celebrations } from "../../utility/interfaces/carePlanInterfaces";
import AllCelebration from "./AllCelebration";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

const CelebrationModalContainer = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(true); // Initial modal open
  const { t } = useTranslation();
  const { preferredLanguage, patientProfileId, patientCaseId, userName } =
    useAppSelector((state) => state.patientOnboardingStatus);

  const { data: celebrationList, isLoading } = useGetCelebrationListQuery(
    {
      patientProfileId,
      preferredLanguage,
      patientCaseId,
    },
    {
      selectFromResult: ({ data, ...rest }) => ({
        data: data?.visualCelebrations
          ? {
              ...data,
              visualCelebrations: [...data.visualCelebrations].sort(
                (a, b) => a.sequence - b.sequence
              ),
            }
          : data,
        ...rest,
      }),
    }
  );

  const celebrations = celebrationList?.visualCelebrations || [];

  const [saveCelebration] = useSaveCelebrationMutation();

  const handleClose = async (celebration: Celebrations) => {
    const isLast = celebrations.length === 1;

    if (isLast) {
      setShowModal(false);
    } else {
      setCurrentIndex(0);
    }

    try {
      await saveCelebration({
        body: { visualCelebrationId: celebration?.visualCelebrationId },
        patientProfileId,
        preferredLanguage,
        patientCaseId,
        userName,
      });
    } catch (error) {
      enqueueSnackbar(t("anErrorOccurred"), { variant: "error" });
    }
  };

  return (
    <>
      {celebrations.length > 0 && showModal && !isLoading && (
        <AllCelebration
          open={showModal}
          onClose={() => handleClose(celebrations[currentIndex])}
          celebration={celebrations[currentIndex]}
        />
      )}
    </>
  );
};

export default CelebrationModalContainer;
